import {
  faCircleExclamation,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const IsErr = ({ err, setErr }) => {
  if (!err) return null;
  return (
    <div className="bg-red-200 border rounded border-red-500 p-2 mb-3 text-red-800 text-sm flex justify-between items-start">
      <span>
        <FontAwesomeIcon icon={faCircleExclamation} /> {err}
      </span>
      <FontAwesomeIcon
        icon={faTimes}
        onClick={() => setErr(null)}
        className="cursor-pointer"
      />
    </div>
  );
};
